import { LOGO_VS_LOGO_LEAGUES } from './leagues';
import type { LogoVsLogoLeague, LogoVsLogoTeam, ShieldVariant } from './types';

export const findLeague = (id: string | undefined): LogoVsLogoLeague | undefined =>
  id ? LOGO_VS_LOGO_LEAGUES.find(l => l.value === id) : undefined;

export const findTeam = (leagueId: string | undefined, teamId: string | undefined): LogoVsLogoTeam | undefined =>
  teamId ? findLeague(leagueId)?.teams.find(t => t.value === teamId) : undefined;

export const findVariant = (team: LogoVsLogoTeam | undefined, hex: string | undefined): ShieldVariant | undefined =>
  hex ? team?.variants.find(v => v.hex === hex || v.visitorHex === hex) : undefined;
